import { render, staticRenderFns } from "./newAddAnnouncement.vue?vue&type=template&id=7dcfcddf&scoped=true"
import script from "./newAddAnnouncement.vue?vue&type=script&lang=js"
export * from "./newAddAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./newAddAnnouncement.vue?vue&type=style&index=0&id=7dcfcddf&prod&scoped=true&lang=scss"
import style1 from "./newAddAnnouncement.vue?vue&type=style&index=1&id=7dcfcddf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcfcddf",
  null
  
)

export default component.exports